var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4",class:_vm.separatorClass,style:(_vm.computedStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }